import { effect, inject, Injectable, signal } from '@angular/core';

import { LocalStorageService } from '@core/common-legacy';

const LS_NAV_MAXIMIZED = 'sidebar_maximized';

@Injectable({
  providedIn: 'root',
})
export class TellentMainNavigationStateService {
  #localStorage = inject(LocalStorageService);
  #localStorageMaximizedValue = this.#localStorage.get(LS_NAV_MAXIMIZED, true);

  public minimized = signal<boolean>(!this.#localStorageMaximizedValue);
  public forceMaximized = signal<boolean>(this.#localStorageMaximizedValue);
  public hovered = signal<boolean>(false);

  constructor() {
    effect(() => this.#localStorage.set(LS_NAV_MAXIMIZED, this.forceMaximized()));
  }
}
